let css = require('./segmented-select.css');
const SELECTOR_OPTION = `.${css.button}`;

class SegmentedSelect {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => {
            let attributes = this.$context.attributes;
            return Object.assign({}, data, attributes, { css });
        });
    }

    bind () {
        return {
            click: {
                [SELECTOR_OPTION]: this.selectTab
            }
        };
    }

    selectTab (e) {
        if (e.target.tagName !== 'A') {
            e.stopPropagation();
        }

        let signal = this.$context.props.signal;

        if (signal) {
            let selectedTab = e.currentTarget.getAttribute('cat-key');
            this.$context.signal(signal, { selectedTab });
        }
    }
}

module.exports = {
    constructor: SegmentedSelect
};





// WEBPACK FOOTER //
// ./packages/account-ui/segmented-select/index.js